module.exports = __webpack_public_path__ + "static/img/son4_active.4f4f354d.png";